import { ChangeDetectorRef, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';
import { NotificationType } from 'src/app/enum/notification-type.enum';
import { ErrorResponseMessage } from 'src/app/error-handler/error-response-message.model';
import { AddUser } from 'src/app/models/manageUsers/add-user.model';
import { LoggerService } from 'src/app/service/logger.service';
import { ManageUserService } from 'src/app/service/manage-user.service';
import * as XLSX from 'xlsx';
import { CommissionService } from 'src/app/service/commission.service';
import { AuthGaurdService } from 'src/app/service/auth-gaurd.service';
import { NotificationService } from 'src/app/service/notification.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ManageCodesService } from 'src/app/service/managecodes.service';


@Component({
  selector: 'app-bulk-update-users',
  templateUrl: './bulk-update-users.component.html',
  styleUrls: ['./bulk-update-users.component.css']
})
export class BulkUpdateUsersComponent implements OnInit, OnDestroy {
  userModel = new AddUser();
  toppings = new FormControl();
  hidefields: boolean = true;
  hideFile: boolean = false;
  value: string | undefined;
  otherFields: boolean = true;
  repUserType: boolean = true;
  managerUserType: boolean = false;
  otherUserType: boolean = false;
  header: string = 'Bulk Update Of Sales Representative';
  sub: any;
  page: string = '';
  data: any[][] = [];
  addUser: AddUser[] = [];
  userData: AddUser[] = [];
  filteredUserData: AddUser[] = [];
  allUserData = new AddUser();
  salesChnlsUserData: AddUser[] = [];
  userTypes: string[] = [];
  comPlansUserData: AddUser[] = [];
  allComPlansUserData: AddUser[] = [];
  salesRepTypes: string[] = [];
  payrollCalender: string[] = [];
  corps: number[] = [];
  supervisorNamesSet = new Set<string>();
  ascCorps: any = [];
  isAscCorp: boolean = true;
  isChecked: string | boolean = "";
  payrollCalendarData: AddUser[] = [];
  rowCount = 0;
  successCount = 0;
  failureCount = 0;
  failedRows = '';
  showUploadResults = false;
  fileProcessing = false;
  fileProgress = 0;
  fileStatusMessage = '';
  private pendingRowCount = 0;
  private pendingFailedRows = '';
  private fileProgressTicker: ReturnType<typeof setInterval> | null = null;
  //page: number;

  @ViewChild('fileInput') fileInput: ElementRef<HTMLInputElement>;

  constructor(private manageCodesService: ManageCodesService, private router: Router,
    private manageUserService: ManageUserService,
    private logger: LoggerService,
    private authgurdService: AuthGaurdService,
    private notificationService: NotificationService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.loadPageData();
  }

  ngOnDestroy(): void {
    this.stopFileProgressTicker();
  }

  private loadPageData(): void {
    forkJoin({
      payroll: this.manageUserService.getPayrollCalendar(),
      fields: this.manageUserService.getPrePopulatedUserData(),
      corps: this.manageCodesService.getCorps(),
    }).subscribe({
      next: (result) => {
        this.payrollCalendarData = result.payroll;
        this.userModel.corps = [];
        this.supervisorNamesSet = this.manageUserService.supervisorNamesSet;
        this.applyPrePopulatedUserData(result.fields);
        this.corps = result.corps.map((corpdata: { corp: number }) => corpdata.corp);
        this.selectedCorps();
      },
      error: (errorResponse: HttpErrorResponse) => {
        const msg: any = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      }
    });
  }

  getPayrollCalendar() {
    this.loadPageData();
  }

  filter() {
    this.hidefields = false;
  }

  selectedUserType(event: any) {
    this.enableFile();
    console.log(event.target.value);
    this.value = event.target.value;
    if (this.value === 'Sales Representative') {
      this.hidefields = true;
      this.otherFields = true;
      this.repUserType = true;
      this.managerUserType = false;
      this.otherUserType = false;
      this.header = 'Bulk Update Of Sales Representative'
    } else if (this.value === 'Supervisor') {
      this.hidefields = false;
      this.otherFields = true;
      this.managerUserType = true;
      this.otherUserType = false;
      this.repUserType = false;
      this.header = 'Bulk Update Of Supervisor/Manager'
    } else if (this.value === 'No Access') {
      this.hidefields = false;
      this.otherFields = true;
      this.managerUserType = true;
      this.otherUserType = false;
      this.repUserType = false;
      this.header = 'Bulk Update Of No Access'
    } else {
      this.hidefields = true;
      this.otherFields = false;
      this.otherUserType = true;
      this.managerUserType = false;
      this.repUserType = false;
      this.header = 'Add Manager/Admin User'
    }
  }

  back() {
    this.router.navigate(['/manage-users']);
  }

  // filterUser(value: any) {
  //   console.log(value[0]);
  //   this.manageUserService.filterByEmpIdHome(value[0])
  //     .subscribe((data: AddUser[]) => {
  //       this.filteredUserData = data;
  //       console.log(this.filteredUserData);
  //       // this.loadData(value);
  //     });
  // }

  onFileChange(evt: any) {

    const target: DataTransfer = <DataTransfer>(evt.target);

    if (target.files.length !== 1) throw new Error('Cannot use multiple files');

    const selectedFile = target.files[0];
    this.startFileProgress('Reading file...');

    // Defer heavy work so the progress bar paints immediately.
    setTimeout(() => this.readSelectedFile(selectedFile), 0);
  }

  private readSelectedFile(selectedFile: File): void {
    const reader: FileReader = new FileReader();

    reader.onprogress = (event: ProgressEvent<FileReader>) => {
      if (event.lengthComputable) {
        this.updateFileProgress(
          Math.max(this.fileProgress, Math.min(35, Math.round((event.loaded / event.total) * 35))),
          'Reading file...'
        );
      }
    };

    reader.onload = (e: any) => {
      this.updateFileProgress(40, 'Parsing Excel...');
      // Yield again so "Parsing Excel..." is visible before XLSX blocks the thread.
      setTimeout(() => this.processExcelContent(e.target.result), 0);
    };

    reader.onerror = () => {
      this.finishFileProgress();
      this.sendNotification(NotificationType.ERROR, `Unable to read the selected file`);
    };

    reader.readAsBinaryString(selectedFile);
  }

  private processExcelContent(bstr: string): void {
    try {
      const wb: XLSX.WorkBook = XLSX.read(bstr, { type: 'binary' });
      const wsname: string = wb.SheetNames[0];
      const ws: XLSX.WorkSheet = wb.Sheets[wsname];
      this.data = (XLSX.utils.sheet_to_json(ws, { header: 1 }));
      const bulkData = this.data.slice(1).filter(row => row && row.length > 0 && row[0] != null && String(row[0]).trim() !== '');
      this.addUser = [];
      this.resetUploadStats();

      if (bulkData.length === 0) {
        this.pendingRowCount = 0;
        this.pendingFailedRows = '';
        this.finishFileProgress();
        this.sendNotification(NotificationType.ERROR, `Please upload valid data`);
        return;
      }

      this.pendingRowCount = bulkData.length;
      this.updateFileProgress(55, `Validating ${bulkData.length} row(s)...`);
      this.startFileProgressTicker(55, 90);

      forkJoin(
        bulkData.map(row =>
          this.manageUserService.filterByEmpIdHome(row[0], this.userModel.effective_date).pipe(
            map(userData => ({ row, userData }))
          )
        )
      ).subscribe(
        (results) => {
          this.stopFileProgressTicker();
          this.updateFileProgress(92, 'Preparing rows...');
          const failedMessages: string[] = [];
          for (const result of results) {
            this.filteredUserData = result.userData;
            if (this.filteredUserData.length > 0) {
              this.loadData(result.row);
            } else {
              const empId = result.row[0] != null ? String(result.row[0]).trim() : '';
              failedMessages.push(`Employee ID ${empId}: No matching user found for the selected effective date`);
            }
          }
          this.pendingFailedRows = failedMessages.join('\n');
          this.updateFileProgress(100, 'File ready');
          setTimeout(() => this.finishFileProgress(), 400);
        },
        (errorResponse: HttpErrorResponse) => {
          const msg: any = errorResponse;
          this.pendingFailedRows = 'File processing failed. Please try again.';
          this.addUser = [];
          this.finishFileProgress();
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        }
      );
    } catch (error) {
      this.finishFileProgress();
      this.sendNotification(NotificationType.ERROR, `Unable to read the selected file`);
    }
  }

  private startFileProgress(message: string): void {
    this.stopFileProgressTicker();
    this.fileProcessing = true;
    this.fileProgress = 8;
    this.fileStatusMessage = message;
    this.cdr.detectChanges();
  }

  private updateFileProgress(progress: number, message: string): void {
    this.fileProcessing = true;
    this.fileProgress = Math.max(this.fileProgress, progress);
    this.fileStatusMessage = message;
    this.cdr.detectChanges();
  }

  private startFileProgressTicker(from: number, max: number): void {
    this.stopFileProgressTicker();
    this.fileProgress = Math.max(this.fileProgress, from);
    this.fileProgressTicker = setInterval(() => {
      if (this.fileProgress < max) {
        this.fileProgress += 1;
        this.cdr.detectChanges();
      }
    }, 200);
  }

  private stopFileProgressTicker(): void {
    if (this.fileProgressTicker) {
      clearInterval(this.fileProgressTicker);
      this.fileProgressTicker = null;
    }
  }

  private finishFileProgress(): void {
    this.stopFileProgressTicker();
    this.fileProcessing = false;
    this.fileProgress = 0;
    this.fileStatusMessage = '';
    this.cdr.detectChanges();
  }

  private resetUploadStats(): void {
    this.showUploadResults = false;
    this.rowCount = 0;
    this.successCount = 0;
    this.failureCount = 0;
    this.failedRows = '';
    this.pendingRowCount = 0;
    this.pendingFailedRows = '';
  }

  private applyUploadResults(successCount: number, failureCount: number, failedRows: string): void {
    this.rowCount = this.pendingRowCount || (successCount + failureCount);
    this.successCount = successCount;
    this.failureCount = failureCount;
    this.failedRows = failedRows;
    this.showUploadResults = true;
  }

  private resetFormFields(): void {
    if (this.fileInput?.nativeElement) {
      this.fileInput.nativeElement.value = '';
    }

    this.userModel = new AddUser();
    this.userModel.corps = [];
    this.userModel.changeColor = [];
    this.userModel.assc_corps = '';
    this.value = undefined;
    this.hidefields = true;
    this.hideFile = false;
    this.otherFields = true;
    this.repUserType = true;
    this.managerUserType = false;
    this.otherUserType = false;
    this.header = 'Bulk Update Of Sales Representative';
    this.isChecked = '';
    this.data = [];
    this.addUser = [];
    this.filteredUserData = [];
    this.pendingRowCount = 0;
    this.pendingFailedRows = '';
    this.finishFileProgress();
    this.filterCommissionPlansBySalesChannel();
    this.selectedCorps();
  }

  downloadFailedRows(): void {
    if (!this.failedRows) {
      return;
    }
    const blob = new Blob([this.failedRows], { type: 'text/plain' });
    const url = window.URL.createObjectURL(blob);
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.download = 'bulk-update-failed-rows.txt';
    anchor.click();
    window.URL.revokeObjectURL(url);
  }

  bulkUpdateUser() {

    console.log(this.userModel.userRole);

    if (this.userModel.userRole === "Sales Representative") {
      this.bulkUpdateUserEmp();
    } else if (this.userModel.userRole === "Supervisor") {
      this.bulkUpdateUserSup();
     } else if (this.userModel.userRole === "No Access") {
      this.bulkUpdateUserSup();
    } else {
      this.bulkUpdateUserSup();
    }


  }

  bulkUpdateUserEmp() {
    if (!this.userModel.userRole) {
      this.sendNotification(NotificationType.ERROR, `Please select User Role`);
    } else if (!this.userModel.user_type) {
      this.sendNotification(NotificationType.ERROR, `Please select User Type`);
    } else if (!this.userModel.effective_date) {
      this.sendNotification(NotificationType.ERROR, `Please select Effective Date`);
    } else if (!this.userModel.calendar_type) {
      this.sendNotification(NotificationType.ERROR, `Please select Calendar Type`);
    } else if (!this.userModel.sales_rep_channel) {
      this.sendNotification(NotificationType.ERROR, `Please select Sales Channel`);
    } else if (!this.userModel.sales_rep_type) {
      this.sendNotification(NotificationType.ERROR, `Please select Sales Rep Type`);
    } else if (!this.userModel.commission_plan) {
      this.sendNotification(NotificationType.ERROR, `Please select Commission Plan`);
    } else if (!this.userModel.commissionable) {
      this.sendNotification(NotificationType.ERROR, `Please select Commissionable`);
    } else if (this.userModel.corps.length === 0) {
      this.sendNotification(NotificationType.ERROR, `Please select Corps`);
    } else {
      this.validateBulkSalesRepIdsBeforeSave(() => this.performBulkUpdate());
    }
  }

  bulkUpdateUserSup() {
    console.log("bulkUpdateUserSup called");
    if (!this.userModel.userRole) {
      this.sendNotification(NotificationType.ERROR, `Please select User Role`);
    } else if (!this.userModel.user_type) {
      this.sendNotification(NotificationType.ERROR, `Please select User Type`);
    } else if (!this.userModel.effective_date) {
      this.sendNotification(NotificationType.ERROR, `Please select Effective Date`);
    } else if (!this.userModel.calendar_type) {
      this.sendNotification(NotificationType.ERROR, `Please select Calendar Type`);
    } else if (!this.userModel.sales_rep_channel) {
      this.sendNotification(NotificationType.ERROR, `Please select Sales Channel`);
    } else if (!this.userModel.sales_rep_type) {
      this.sendNotification(NotificationType.ERROR, `Please select Sales Rep Type`);
    } else if (!this.userModel.commission_plan) {
      this.sendNotification(NotificationType.ERROR, `Please select Commission Plan`);
    } else if (!this.userModel.commissionable) {
      this.sendNotification(NotificationType.ERROR, `Please select Commissionable`);
    } else {
      this.validateBulkSalesRepIdsBeforeSave(() => this.performBulkUpdate());
    }
  }

  enableFile() {
    console.log(this.userModel.userRole);
    if (!this.userModel.userRole) {
      //this.sendNotification(NotificationType.ERROR, `Please select User Role`);
    } else if (!this.userModel.user_type) {
      //this.sendNotification(NotificationType.ERROR, `Please select User Type`);
    } else if (!this.userModel.effective_date) {
      //this.sendNotification(NotificationType.ERROR, `Please select Effective Date`);
    } else if (!this.userModel.calendar_type) {
      //this.sendNotification(NotificationType.ERROR, `Please select Calendar Type`);
    } else if (!this.userModel.sales_rep_channel) {
      //this.sendNotification(NotificationType.ERROR, `Please select Sales Channel`);
    } else if (!this.userModel.sales_rep_type) {
      //this.sendNotification(NotificationType.ERROR, `Please select Sales Rep Type`);
    } else if (!this.userModel.commission_plan) {
      //this.sendNotification(NotificationType.ERROR, `Please select Commission Plan`);
    } else if (this.userModel.corps.length === 0) {
      //this.sendNotification(NotificationType.ERROR, `Please select Corps`);
    } else {

      this.hideFile = true;
    }

    if (this.userModel.userRole === "Supervisor") {
      this.hideFile = true;
    }

     if (this.userModel.userRole === "No Access") {
      this.hideFile = true;
     }

  }



  private validateBulkSalesRepIdsBeforeSave(onSuccess: () => void): void {
    const rowsToValidate = this.addUser.filter(row =>
      row.sales_rep_id &&
      row.sales_rep_id.trim() !== '' &&
      row.sales_rep_id !== 'NA'
    );

    if (rowsToValidate.length === 0) {
      onSuccess();
      return;
    }

    const validations = rowsToValidate.map(row =>
      this.manageUserService.validateSalesRepId(
        row.sales_rep_id.trim(),
        row.id || '',
        this.userModel.effective_date
      ).pipe(map(isDuplicate => ({ row, isDuplicate })))
    );

    forkJoin(validations).subscribe(
      results => {
        const duplicate = results.find(result => result.isDuplicate);
        if (duplicate) {
          this.sendNotification(
            NotificationType.ERROR,
            `The Sales Rep ID is assigned to an Active user, please use a different Sales Rep ID (Employee ID: ${duplicate.row.employeeId})`
          );
          return;
        }
        onSuccess();
      },
      () => onSuccess()
    );
  }

  private performBulkUpdate(): void {
    const checkboxChecked = (this.isChecked === true || this.isChecked === 'true') ? 'true' : 'false';
    this.isChecked = checkboxChecked;

    if (this.addUser.length > 0) {
      this.addUser.forEach(user => {
        user.checkboxchecked = checkboxChecked;
      });
      const pendingCount = this.addUser.length;
      const preUploadFailures = this.pendingFailedRows
        ? this.pendingFailedRows.split('\n').filter(row => row.trim() !== '').length
        : 0;
      this.manageUserService.bulkUpdate(this.addUser)
        .subscribe(response => {
          console.log(JSON.stringify(response));
          this.applyUploadResults(pendingCount, preUploadFailures, this.pendingFailedRows);
          this.resetFormFields();
          this.sendNotification(NotificationType.SUCCESS, `Added/Updated Successfully`);
        }, (errorResponse: HttpErrorResponse) => {
          var msg: any;
          msg = errorResponse;
          const saveFailureMsg = 'Upload failed for all pending rows.';
          const failedRows = this.pendingFailedRows
            ? this.pendingFailedRows + '\n' + saveFailureMsg
            : saveFailureMsg;
          this.applyUploadResults(0, this.pendingRowCount || pendingCount, failedRows);
          this.notificationService.sendNotification(NotificationType.ERROR, msg);
        });
    } else {
      if (this.pendingRowCount > 0) {
        this.applyUploadResults(0, this.pendingRowCount, this.pendingFailedRows || 'Please upload valid data');
      }
      this.sendNotification(NotificationType.ERROR, `Please upload valid data`);
    }
  }

  loadData(data: any) {
    console.log("loadData called");
    //this.addUser = [];
    let i = 0
    const userModl = new AddUser();
    //userModl.checkboxchecked = "true";
    userModl.employeeId = data[0];
    userModl.supervisor_id = data[1];
    userModl.supervisor_name = data[2];
    userModl.sales_rep_id = data[3];

    console.log(this.userModel);

    userModl.userRole = this.userModel.userRole;
    userModl.user_type = this.userModel.user_type;
    userModl.effective_date = this.userModel.effective_date;
    userModl.calendar_type = this.userModel.calendar_type;
    userModl.sales_rep_channel = this.userModel.sales_rep_channel;
    userModl.sales_rep_type = this.userModel.sales_rep_type;
    userModl.commission_plan = this.userModel.commission_plan;
    userModl.commPlanId = this.userModel.commission_plan != null ? String(this.userModel.commission_plan) : null;
    userModl.commissionable = this.userModel.commissionable;
    userModl.soft_termination_date = this.userModel.soft_termination_date;
    userModl.supervisor_name = userModl.supervisor_name;//this.filteredUserData[0].supervisor_name;

    if (this.userModel.corps.length > 0) {
      this.userModel.assc_corps = this.userModel.corps.toString();
    } else {
      this.userModel.assc_corps = "";
    }
    userModl.assc_corps = this.userModel.assc_corps;

    console.log(this.filteredUserData);

    userModl.id = this.filteredUserData[0].id;
    userModl.rowid = this.filteredUserData[0].rowid;
    userModl.first_name = this.filteredUserData[0].first_name;
    userModl.last_name = this.filteredUserData[0].last_name;
    userModl.middle_name = this.filteredUserData[0].middle_name;
    userModl.email_address = this.filteredUserData[0].email_address;
    userModl.network_id = this.filteredUserData[0].network_id;
    userModl.joining_date = this.filteredUserData[0].joining_date;
    userModl.pref_first_name = this.filteredUserData[0].pref_first_name;
    userModl.pref_last_name = this.filteredUserData[0].pref_last_name;
    userModl.sales_rep_channel_desc = this.userModel.sales_rep_channel_desc
      || this.filteredUserData[0].sales_rep_channel_desc;
    userModl.std_hours = this.filteredUserData[0].std_hours;
    userModl.supervisor_pref_name = this.filteredUserData[0].supervisor_pref_name;
    userModl.termination_date = this.filteredUserData[0].termination_date;
    userModl.vacation_start_date = this.filteredUserData[0].vacation_start_date;
    userModl.vacation_end_date = this.filteredUserData[0].vacation_end_date;
    userModl.work_status = this.filteredUserData[0].work_status;

    userModl.profileStatus = 'complete';
    userModl.created_dt = new Date();
    userModl.created_by = localStorage.getItem('CURRENT_USER_NAME_SESSION');

    console.log(userModl);

    this.addUser.push(userModl);
    console.log(this.addUser);
  }



  checkValue(event: any) {
    this.isChecked = event.checked;
    console.log(this.isChecked);
  }

  getPrePopulatedUserData() {
    this.loadPageData();
  }

  private applyPrePopulatedUserData(data: AddUser[]): void {
    this.logger.info(data);
    this.userData = data;
    this.salesChnlsUserData = [];
    this.userTypes = [];
    this.allComPlansUserData = [];
    this.salesRepTypes = [];
    this.payrollCalender = [];

    for (const userInfo of data) {
      if (userInfo.commission_plan != null) {
        this.allComPlansUserData.push(userInfo);
      } else if (userInfo.sales_rep_channel != null && userInfo.sales_rep_channel_desc != null) {
        this.salesChnlsUserData.push(userInfo);
      } else if (userInfo.user_type != null) {
        this.userTypes.push(userInfo.user_type);
      } else if (userInfo.sales_rep_type != null) {
        this.salesRepTypes.push(userInfo.sales_rep_type);
      } else if (userInfo.calendar_type != null) {
        this.payrollCalender.push(userInfo.calendar_type);
      }
    }

    this.allComPlansUserData.sort((a, b) => (a.commission_plan < b.commission_plan) ? -1 : 1);
    this.userTypes.sort((a, b) => a.localeCompare(b));
    this.salesRepTypes.sort((a, b) => a.localeCompare(b));
    this.payrollCalender.sort((a, b) => a.localeCompare(b));
    this.filterCommissionPlansBySalesChannel();
  }

  onSalesChannelChange(): void {
    const selectedChannel = this.salesChnlsUserData.find(
      channel => channel.sales_rep_channel === this.userModel.sales_rep_channel
    );
    if (selectedChannel) {
      this.userModel.sales_rep_channel_desc = selectedChannel.sales_rep_channel_desc;
    }
    this.filterCommissionPlansBySalesChannel();
    this.enableFile();
  }

  private filterCommissionPlansBySalesChannel(): void {
    const source = this.allComPlansUserData;

    if (!this.userModel.sales_rep_channel) {
      this.comPlansUserData = source.slice()
        .sort((a, b) => (a.commission_plan < b.commission_plan) ? -1 : 1);
      return;
    }

    const selectedChannel = this.salesChnlsUserData.find(
      channel => channel.sales_rep_channel === this.userModel.sales_rep_channel
    );
    const channelDesc = selectedChannel?.sales_rep_channel_desc ?? this.userModel.sales_rep_channel_desc;

    this.comPlansUserData = source
      .filter(plan => this.planMatchesSalesChannel(plan, this.userModel.sales_rep_channel, channelDesc))
      .sort((a, b) => (a.commission_plan < b.commission_plan) ? -1 : 1);

    if (this.userModel.commission_plan != null &&
      !this.comPlansUserData.some(plan => Number(plan.comm_plan_id) === Number(this.userModel.commission_plan))) {
      this.userModel.commission_plan = null;
    }
  }

  private requiresExactChannelMatch(channelCode: string, channelDesc: string): boolean {
    const combined = `${channelCode || ''} ${channelDesc || ''}`.toLowerCase();
    return combined.includes('direct sales') && combined.includes('bpo');
  }

  private channelValuesMatchExactly(left: string, right: string): boolean {
    return !!left && !!right && left === right;
  }

  private planMatchesSalesChannel(plan: AddUser, channelCode: string, channelDesc: string): boolean {
    const planChannel = this.normalizeValue(plan.sales_rep_channel || '');
    const planDesc = this.normalizeValue(plan.sales_channel_desc || '');
    const channelToken = this.normalizeValue(channelCode || '');
    const descToken = this.normalizeValue(channelDesc || '');

    if (this.requiresExactChannelMatch(channelCode, channelDesc)) {
      return this.channelValuesMatchExactly(planChannel, channelToken)
        || this.channelValuesMatchExactly(planDesc, descToken)
        || this.channelValuesMatchExactly(planChannel, descToken)
        || this.channelValuesMatchExactly(planDesc, channelToken);
    }

    const planValues = [planChannel, planDesc].filter(value => value.length > 0);
    const matchTokens = [channelToken, descToken].filter(value => value.length > 0);

    for (const token of matchTokens) {
      for (const planValue of planValues) {
        if (planValue === token) {
          return true;
        }
        if (planValue.startsWith(token) || token.startsWith(planValue)) {
          return true;
        }
      }
    }
    return false;
  }

  private normalizeValue(value: string | null | undefined): string {
    return (value ?? '').toString().toLowerCase().replace(/\s/g, '');
  }

  getCorps() {
    this.manageCodesService.getCorps()
      .subscribe((data: any) => {
        this.corps = data.map((corpdata: { corp: number }) => corpdata.corp);
        this.selectedCorps();
      }, (errorResponse: HttpErrorResponse) => {
        var msg: any;
        msg = errorResponse;
        this.notificationService.sendNotification(NotificationType.ERROR, msg);
      });
  }

  selectedCorps() {
    this.userModel.changeColor = [];
    this.userModel.corps = [];
    const selectedCorpSet = new Set<number>();

    if (this.userModel.assc_corps) {
      this.ascCorps = this.userModel.assc_corps.split(',');
      this.ascCorps.forEach((value: any) => {
        const numeric = Number(value);
        if (!Number.isNaN(numeric)) {
          this.userModel.corps.push(numeric);
          selectedCorpSet.add(numeric);
        }
      });
    }

    for (const corp of this.corps) {
      this.userModel.changeColor.push(selectedCorpSet.has(corp));
    }
  }


  checkAll() {
    this.hideFile = true;
    this.userModel.changeColor = [];
    this.userModel.corps = [];
    for (let corp of this.corps) {
      this.userModel.changeColor.push(true);
      this.userModel.corps.push(corp);
    }
  }

  uncheckAll() {
    this.hideFile = false;
    this.userModel.changeColor = this.corps.map(() => false);
    this.userModel.corps = [];
  }

  clickedRow(e: any) {

    //this.userModel.corps =[];
    var numeric = Number(e.target.innerText);
    //console.log("hhkhhh  ", numeric);
    //var exists = msgArr.some(o => o.objectId === data.objectId);
    if (!this.userModel.corps.includes(numeric)) {
      //console.log('value is not exist', e.target.innerText)
      this.userModel.corps.push(numeric);
    } else if (this.userModel.corps.includes(numeric)) {
      //console.log('value is  exist', numeric)
      this.userModel.corps.forEach((element: number, index: any) => {
        if (element == e.target.innerText) this.userModel.corps.splice(index, 1);
      });
    }
    //console.log(this.userModel.corps);
    //console.log(this.userModel.corps.length);
    if (this.userModel.corps.length > 0) {
      this.hideFile = true;
    } else {
      this.hideFile = false;
    }
  }

  private sendNotification(notificationType: NotificationType, message: string): void {
    if (message) {
      this.notificationService.notify(notificationType, message);
    } else {
      this.notificationService.notify(notificationType, 'An error occurred. Please try again.');
    }
  }

  isLastDayOfMonth(date: Date | null): boolean {
    date = date ?? new Date();
    const dayOfMonth = date.getDate();
    const lastDayOfMonth = getLastDayOfMonth(date);

    return dayOfMonth === lastDayOfMonth;
  };

}

function getLastDayOfMonth(date: Date): number {
  return new Date(date.getFullYear(), date.getMonth(), 1).getDate();
}
